import { render, staticRenderFns } from "./vuePaymentAmount.vue?vue&type=template&id=6788c63d"
import script from "./vuePaymentAmount.vue?vue&type=script&lang=js"
export * from "./vuePaymentAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports